import React from 'react';
import { motion } from 'framer-motion';
import { Upload, FileText, Users } from 'lucide-react';

const ContactEmptyState = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="py-8 text-center sm:py-12 lg:py-16"
    >
      <div className="px-4 mx-auto max-w-md">
        {/* Icon */}
        <div className="flex justify-center items-center mx-auto mb-4 w-16 h-16 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full sm:w-20 sm:h-20 lg:w-24 lg:h-24 sm:mb-6">
          <Users className="w-8 h-8 text-blue-600 sm:w-10 sm:h-10 lg:w-12 lg:h-12" />
        </div>

        {/* Title */}
        <h3 className="mb-2 text-lg font-bold text-gray-900 sm:text-xl lg:text-2xl sm:mb-3">
          No Contact Groups Yet
        </h3>

        {/* Description */}
        <p className="mb-6 text-sm text-gray-600 sm:text-base sm:mb-8">
          Get started by uploading your first contact list. You can organize contacts into groups for better management.
        </p>

        {/* Features */}
        <div className="mb-6 space-y-3 sm:space-y-4 sm:mb-8">
          {[
            {
              icon: Upload,
              title: 'Easy Upload',
              description: 'Upload XLS or XLSX files'
            },
            {
              icon: Users,
              title: 'Organize Groups',
              description: 'Keep your contacts organized'
            },
            {
              icon: FileText,
              title: 'Manage Lists',
              description: 'Edit and maintain your contacts'
            }
          ].map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="flex gap-3 items-center text-left sm:gap-4">
                <div className="flex flex-shrink-0 justify-center items-center w-8 h-8 bg-blue-50 rounded-lg sm:w-10 sm:h-10">
                  <Icon className="w-4 h-4 text-blue-600 sm:w-5 sm:h-5" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-gray-900 sm:text-base">{feature.title}</h4>
                  <p className="text-xs text-gray-600 sm:text-sm">{feature.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <button 
          onClick={() => window.location.href = '/contacts/upload'}
          className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-lg sm:rounded-xl font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-sm sm:text-base"
        >
          Upload Your First Contact List
        </button>
      </div>
    </motion.div>
  );
};

export default ContactEmptyState; 